import React, { useState, useEffect, useRef } from 'react'
import './Education.css'

export default function Education() {
  const [modulActiv, setModulActiv] = useState(0)

  const module = [
    { titlu: 'RNG Explicat', icon: '🎲', component: <ModulRNG /> },
    { titlu: 'Iluzia controlului', icon: '🎮', component: <ModulControl /> },
    { titlu: '10.000 spinuri', icon: '📊', component: <Modul10k /> },
    { titlu: 'Jackpot-ul', icon: '💰', component: <ModulJackpot /> },
    { titlu: 'Near Miss', icon: '🧠', component: <ModulNearMiss /> },
  ]

  return (
    <div className="education-page">
      <div className="edu-header">
        <h1>Cum functioneaza aparatele</h1>
        <p className="edu-sub">5 lucruri pe care casele de pariuri nu vor sa le stii</p>
      </div>

      <div className="edu-tabs">
        {module.map((m, i) => (
          <button key={i} className={`edu-tab ${modulActiv === i ? 'active' : ''}`} onClick={() => setModulActiv(i)}>
            <span>{m.icon}</span>
            <span>{m.titlu}</span>
          </button>
        ))}
      </div>

      <div className="edu-content">
        {module[modulActiv].component}
      </div>
    </div>
  )
}

function ModulRNG() {
  const [rezultate, setRezultate] = useState([])
  const [running, setRunning] = useState(false)

  function genereaza() {
    setRunning(true)
    setRezultate([])
    let i = 0
    const interval = setInterval(() => {
      setRezultate(prev => [...prev, Math.floor(Math.random() * 100) + 1])
      i++
      if (i >= 20) { clearInterval(interval); setRunning(false) }
    }, 150)
  }

  return (
    <div className="modul">
      <h2>Fiecare spin este complet independent</h2>
      <p className="modul-desc">Aparatul nu are memorie. Nu exista "e cald" sau "urmeaza un castig". Fiecare spin are exact aceeasi probabilitate indiferent de ce s-a intamplat inainte.</p>
      <button className="btn-primary" onClick={genereaza} disabled={running}>
        {running ? 'Se genereaza...' : 'Genereaza 20 numere random'}
      </button>
      {rezultate.length > 0 && (
        <div className="rng-results">
          {rezultate.map((r, i) => (
            <div key={i} className="rng-num" style={{ background: r > 92 ? 'var(--green-pale)' : 'var(--cream)', color: r > 92 ? 'var(--green)' : 'var(--text)' }}>
              {r}
            </div>
          ))}
        </div>
      )}
      {rezultate.length === 20 && (
        <div className="modul-concluzie">
          ✓ Observa: nicio logica, niciun pattern. Aparatul genereaza exact asa la fiecare spin. <strong>Nu poti prezice ce urmeaza.</strong>
        </div>
      )}
    </div>
  )
}

function ModulControl() {
  const [rezultatTu, setRezultatTu] = useState(null)
  const [rezultatAuto, setRezultatAuto] = useState(null)
  const SIMBOLURI = ['🍒','🍋','⭐','🔔','💎','🎰']

  function spinTu() {
    setRezultatTu([0,1,2].map(() => SIMBOLURI[Math.floor(Math.random()*SIMBOLURI.length)]))
    setRezultatAuto([0,1,2].map(() => SIMBOLURI[Math.floor(Math.random()*SIMBOLURI.length)]))
  }

  return (
    <div className="modul">
      <h2>Conteaza cand apesi butonul?</h2>
      <p className="modul-desc">Multi dependenti cred ca au un "ritm" sau un "moment perfect" pentru a apasa. Acest experiment demonstreaza ca nu exista nicio diferenta.</p>
      <div className="control-grid">
        <div className="control-col">
          <div className="control-label">Tu apesi</div>
          <div className="control-reels">{rezultatTu ? rezultatTu.map((s,i) => <span key={i}>{s}</span>) : <span style={{opacity:0.3}}>?</span>}</div>
        </div>
        <div className="control-vs">VS</div>
        <div className="control-col">
          <div className="control-label">Automat</div>
          <div className="control-reels">{rezultatAuto ? rezultatAuto.map((s,i) => <span key={i}>{s}</span>) : <span style={{opacity:0.3}}>?</span>}</div>
        </div>
      </div>
      <button className="btn-primary" onClick={spinTu}>Apasa tu acum</button>
      {rezultatTu && <div className="modul-concluzie">Ambele folosesc acelasi RNG. <strong>Nu exista moment "bun" pentru a apasa.</strong></div>}
    </div>
  )
}

function Modul10k() {
  const [progress, setProgress] = useState(0)
  const [balanta, setBalanta] = useState(0)
  const [running, setRunning] = useState(false)
  const rafRef = useRef(null)

  function ruleaza() {
    setRunning(true)
    setProgress(0)
    setBalanta(0)
    let b = 0, i = 0
    const BATCH = 200

    function step() {
      for (let j = 0; j < BATCH && i < 10000; j++, i++) {
        const castig = Math.random() < 0.08
        b += castig ? (2 * 0.75) : -2
      }
      setProgress(i)
      setBalanta(Math.round(b))
      if (i < 10000) rafRef.current = requestAnimationFrame(step)
      else setRunning(false)
    }
    rafRef.current = requestAnimationFrame(step)
  }

  useEffect(() => () => cancelAnimationFrame(rafRef.current), [])

  const pct = Math.round((progress / 10000) * 100)

  return (
    <div className="modul">
      <h2>Ce se intampla in 10.000 de spinuri?</h2>
      <p className="modul-desc">Simulam 10.000 de spinuri cu o miza de 2 lei/spin si o probabilitate de castig de 8% (castig = 75% din miza). Vezi singur rezultatul final.</p>
      <button className="btn-primary" onClick={ruleaza} disabled={running}>
        {running ? `Se simuleaza... ${pct}%` : 'Ruleaza simularea'}
      </button>
      {progress > 0 && (
        <>
          <div className="sim-progress"><div className="sim-progress-fill" style={{width:`${pct}%`}}/></div>
          <div className="sim-stats">
            <div className="sim-stat"><div className="sim-stat-num">{progress.toLocaleString()}</div><div className="sim-stat-lbl">spinuri</div></div>
            <div className="sim-stat"><div className="sim-stat-num" style={{color: balanta < 0 ? 'var(--red)' : 'var(--green)'}}>{balanta > 0 ? '+' : ''}{balanta} lei</div><div className="sim-stat-lbl">balanta</div></div>
            <div className="sim-stat"><div className="sim-stat-num">{(progress * 2).toLocaleString()} lei</div><div className="sim-stat-lbl">bagat total</div></div>
          </div>
          {progress === 10000 && <div className="modul-concluzie red">Dupa 10.000 spinuri si {(10000*2).toLocaleString()} lei investiti: <strong>{balanta} lei balanta finala.</strong> Casa castiga mereu pe termen lung.</div>}
        </>
      )}
    </div>
  )
}

function ModulJackpot() {
  const [spinuriSec, setSpinuriSec] = useState(1)
  const PROB = 1 / 50000
  const spinuriNecesare = Math.round(1 / PROB)
  const secunde = spinuriNecesare / spinuriSec
  const ore = Math.round(secunde / 3600)
  const zile = Math.round(secunde / 86400)
  const ani = (secunde / (365 * 86400)).toFixed(1)

  return (
    <div className="modul">
      <h2>Cat de real este jackpot-ul?</h2>
      <p className="modul-desc">Jackpot-urile sunt programate cu probabilitati extrem de mici. Iata cat ar dura sa il castigi daca joci non-stop:</p>
      <div className="jackpot-prob">
        <div className="jp-num">1 la {spinuriNecesare.toLocaleString()}</div>
        <div className="jp-lbl">probabilitate castig jackpot</div>
      </div>
      <div className="modul-field">
        <label>Spinuri pe secunda: {spinuriSec}</label>
        <input type="range" min="1" max="10" value={spinuriSec} onChange={e => setSpinuriSec(Number(e.target.value))} style={{width:'100%', margin:'8px 0'}}/>
      </div>
      <div className="jackpot-timp">
        <div className="jp-timp-item"><div className="jp-timp-num">{ore.toLocaleString()}</div><div className="jp-timp-lbl">ore</div></div>
        <div className="jp-timp-item"><div className="jp-timp-num">{zile.toLocaleString()}</div><div className="jp-timp-lbl">zile</div></div>
        <div className="jp-timp-item"><div className="jp-timp-num">{ani}</div><div className="jp-timp-lbl">ani</div></div>
      </div>
      <div className="modul-concluzie red">Jucand {spinuriSec} spin(uri)/secunda, non-stop, fara somn, ai castiga jackpotul dupa <strong>{ani} ani</strong>.</div>
    </div>
  )
}

function ModulNearMiss() {
  const [reels, setReels] = useState(['🍒','🍒','❌'])
  const [mesaj, setMesaj] = useState('')
  const SIMBOLURI = ['🍒','🍋','⭐','🔔']

  function genNearMiss() {
    const s = SIMBOLURI[Math.floor(Math.random()*SIMBOLURI.length)]
    let s3
    do { s3 = SIMBOLURI[Math.floor(Math.random()*SIMBOLURI.length)] } while (s3 === s)
    setReels([s, s, s3])
    setMesaj('Aproape! Dar nu... Aceasta este programata intentionat. Aparatul afiseaza 2 simboluri identice de 40-45% din timp la pierderi, tocmai ca sa creeze iluzia ca esti "aproape".')
  }

  return (
    <div className="modul">
      <h2>Near Miss — aproape, dar nu</h2>
      <p className="modul-desc">Creierul tau interpreteaza 🍒🍒❌ ca "aproape un castig" si elibereaza dopamina. Dar matematic e identic cu 🍒🎰🔔 — o pierdere totala.</p>
      <div className="near-miss-reels">
        {reels.map((s, i) => <div key={i} className={`nm-reel ${i === 2 && reels[0] === reels[1] ? 'reel-miss' : ''}`}>{s}</div>)}
      </div>
      <button className="btn-primary" onClick={genNearMiss}>Genereaza near-miss</button>
      {mesaj && <div className="modul-concluzie amber">{mesaj}</div>}
      <div className="near-miss-fact">
        <strong>Fapt stiintific:</strong> Aparatele sunt programate sa afiseze near-miss-uri de 30-45% din pierderi.
        Aceasta frecventa mentine jucatorul angajat mai mult decat piederile clare.
      </div>
    </div>
  )
}
